module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/process/process-03-3794de8f7cb47d92069cdd2f176d8992.svg";